<template>
  <div class="w-full" v-if="!mate?.isUser">
    <div class="flex items-center justify-between my-1 border-t pt-1">
      <p class="">语音</p>
      <div class="flex items-center gap-1">
        <button class="btn btn-xs" @click="show = true">修改音色</button>
        <button class="btn btn-xs" v-if="activeMedia" @click="handleRemove">
          移除语音
        </button>
      </div>
    </div>
    <MateToneModulePlay
      v-if="mate.mateToneId"
      :mate-tone-id="mate.mateToneId"
      :text="text"
      :mate-tone-config="mate.mateToneConfig"
      :tone-type="toneType"
      :active-media="activeMedia"
      @generate="handleGenerate"
    />
    <div v-else class="flex items-center justify-between">
      <p class="text-base-content/60">选择音色可以发布语音动态</p>
      <button class="btn btn-xs btn-primary" @click="show = true">
        选择OC音色
      </button>
    </div>

    <VanPopup
      v-model:show="show"
      position="bottom"
      class="h-full overflow-hidden"
    >
      <MateToneModule
        :hide-custom-tone="true"
        :mate-uuid="mate.uuid"
        @save="handleSave"
      />
    </VanPopup>
  </div>
</template>

<script setup lang="ts">
import { Mate, Media } from "@/types/entity";
import { ref } from "vue";

defineProps<{
  mate: Mate;
  text: string;
  toneType: "voice" | "tryListen";
  activeMedia?: Media;
}>();

const emit = defineEmits<{
  (e: "generate", media?: Media): void;
}>();

const show = ref(false);

const handleGenerate = (media: Media) => {
  emit("generate", media);
};

const handleSave = () => {
  show.value = false;
};

const handleRemove = () => {
  emit("generate", undefined);
};
</script>
